import { v4 } from "uuid";

// returns first part of uuid
// #####-#####-#####-##### --> #####
const getShortUuid = (): string => {
  const uuid = v4();
  const uuidParts = uuid.split("-");

  return uuidParts[0];
};

export const generateIdWithPrefix = (prefix: string | number) =>
  `${prefix}_${getShortUuid()}`;

export default getShortUuid;
